import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import './HeroBanner.css';

const slides = [
  { image: require('../../Assets/Hero.png'), title: "Safari ya Maarifa: Learn, Discover & Grow.", subTitle: "Your syllabus, your pace, your mastery." },
  { image: require('../../Assets/Hero2.jpg'), title: "Fikia Malengo Yako: Learn Today, Lead Tomorrow", subTitle: "Where curiosity meets expertise." },
  { image: require('../../Assets/Hero3.jpg'), title: "Jifunze Nasi: Your Journey to Excellence", subTitle: "Your roadmap to top grades." }
];

function HeroBanner({ isLoggedIn }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const handleGetStartedClick = () => {
    navigate("/signUp");
  };

    const handleGoToGooglePlay = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.oxenspace.BeyondschoolsApp",
      "_blank"
    );
  };

  const handleGoToAppStore = () => {
    window.open(
      "https://apps.apple.com/app/idXXXXXXXXX",
      "_blank"
    );
  };

  return (
    <div className='hero-container'>
      <div className='hero-sections'>
          <div className='hero-text'>
              <div className="store-icons">
            <img
              src={require('../../Assets/googleplay.png')}
              alt="Google Play"
              className="promo-image"
              onClick={handleGoToGooglePlay}
              style={{ cursor: 'pointer' }}
            />
            {/* <img
              src={require('../../Assets/appstore.png')}
              alt="App Store"
              className="promo-image"
              onClick={handleGoToAppStore}
              style={{ cursor: 'pointer' }}
            /> */}
          </div>
          <h2 className='hero-text-title'>Download Our App</h2>
          <p className='hero-text-submenu'>Learn easily from your phone — access videos, quizzes, and lessons anywhere, anytime!</p>
          {!isLoggedIn && (
           <button className="hero-register-btn" onClick={handleGetStartedClick}>
            Get Started Now
          </button>
          )}
        </div>
        <div className='hero-image'>
              <img
              src={require('../../Assets/scren.png')}
              alt="Mobile App"
              className="hero-promo-image"
              onClick={handleGoToGooglePlay}
              style={{ cursor: 'pointer' }}
            />
        </div>
      </div>
    </div>
    // <div className='hero-container' style={{ backgroundImage: `url(${slides[currentSlide].image})` }}>
    //   <div className='hero-overlay'>
    //     <div className='hero-placing'>
    //       <span className='header-title'>{slides[currentSlide].title}</span>
    //       <span className='sub-header-text'>{slides[currentSlide].subTitle}</span>
    //     </div>
    //     {!isLoggedIn && (
    //       <div className='hero-call-to-action'>
    //         <span className="start-user" onClick={handleGetStartedClick}>Get Started</span>
    //       </div>
    //     )}
    //   </div>
    //   {/* Slide Navigation Dots */}
    //   <div className="slide-dots">
    //     {slides.map((_, index) => (
    //       <span
    //         key={index}
    //         className={`dot ${currentSlide === index ? "active" : ""}`}
    //         onClick={() => setCurrentSlide(index)}
    //       />
    //     ))}
    //   </div>
    // </div>
  );
} 

export default HeroBanner;
